export const SUBSCRIBE = 'subscribe'
export const MESSAGE = 'message'

export enum CommandType {
  SUBSCRIBE = 'subscribe',
  MESSAGE = 'message'
}

export interface SocketMessage {
  command: string;
  channel: string;
  payload: string;
}

export interface SocketMessagePayloadResponse {
  event: string;
  sentAt?: number;
  value: PayloadValue;
}

export interface SocketMessagePayloadRequest {
  trigger: string;
  sentAt?: number;
  value: PayloadValue;
}

export interface PayloadValue {
  id: string;
  time?: number;
  pages?: number; // used for Hyrox Whiteboard
  scheduled?: boolean;
  workoutPartIdx?: number;
  timeFrameIdx?: number;
}

export interface CtrlCmdMessage {
  trigger: CTRL_COMMAND;
  value: PayloadValue | TimerPayloadValue | WorkoutPreviewPayloadValue | HyroxWorkoutPreviewPayloadValue;
  sentAt?: number;
}

export interface FeedbackCtrlCmdMessage {
  event: CTRL_COMMAND_FEEDBACK;
  value: PayloadValue;
  sentAt?: number;
}

export interface TimerPayloadValue {
  id: string;
  duration?: number;
  workInterval?: number;
  restInterval?: number;
  rounds?: number;
}

export interface WorkoutPreviewPayloadValue {
  id: string;
  type: string;
  workoutPartIdx: number;
  workoutRoundIdx?: number;
  slideIdx?: number;
}

export interface HyroxWorkoutPreviewPayloadValue extends WorkoutPreviewPayloadValue {
  coachTips?: Array<{[key: string]: number|string}>
  page?: number
}

export enum CTRL_COMMAND {

  LESSON_START = 'lessonstart',
  LESSON_PAUSE = 'lessonpause',
  LESSON_RESUME = 'lessonresume',
  LESSON_STOP = 'lessonstop',
  WORKOUT_START = 'workout-start',
  WORKOUT_PAUSE = 'workout-pause',
  WORKOUT_RESUME = 'workout-resume',
  WORKOUT_STOP = 'workout-stop',
  WORKOUT_FORWARD = 'workout-forward',
  WORKOUT_BACKWARD = 'workout-backward',
  WORKOUT_LOAD = 'workout-load',
  WORKOUT_PREVIEW_START = 'workout-preview-start',
  WORKOUT_PREVIEW_STOP = 'workout-preview-stop',
  WORKOUT_PREVIEW_CHANGE_ROUND = 'workout-preview-change-round',
  WORKOUT_PREVIEW_CHANGE_PART = 'workout-preview-change-part',
  WORKOUT_PREVIEW_CHANGE_SLIDE = 'workout-preview-change-slide',
  MONTHLY_START = 'monthly-start',
  MSS_START = 'mss-start',
  PING = 'ping',
  TIMER_START = 'timer-start',
  REALTIME_WORKOUT_UPDATE = 'workout-realtime-update',
  REALTIME_WORKOUT_HYROX_UPDATE = 'workout-hyrox-realtime-update',
  REALTIME_WORKOUT_MSS_UPDATE = 'workout-mss-realtime-update',
  REALTIME_WORKOUT_SCHEDULE_UPDATE = 'workout-schedule-update',
  REALTIME_WORKOUT_MSS_SCHEDULE_UPDATE = 'workout-mss-schedule-update',
  REALTIME_WORKOUT_HYROX_SCHEDULE_UPDATE = 'workout-hyrox-schedule-update',
  REALTIME_VIRTUAL_CLASS_SCHEDULE_UPDATE = 'virtual-classes-schedule-update',
  REALTIME_MT_SCHEDULE_UPDATE  = 'monthly-trainings-schedule-update',
  CELEBRATION_START = 'celebration-start',
  UPDATE_EGYM_TRAINING_PLANS = 'egym-training-plans-update',
  RESET_EGYM_TRAINING_PLANS = 'egym-training-plans-reset',
  HYROX_WORKOUT_PREVIEW_START = 'hyrox-workout-preview-start',
  HYROX_START = 'hyrox-start',
  HYROX_MESSAGE = 'hyrox-message',
  HYROX_STOP = 'hyrox-stop',
  MSS_HYROX_START = 'mss-hyrox-start',
  MSS_VELOCITY_START = 'mss-velocity-start',
  HYROX_WHITEBOARD_ACTIVATE = 'hyrox-whiteboard-activate',
  HYROX_WHITEBOARD_SHOW_COACHTIPS = 'hyrox-whiteboard-show-coachtips',
  HYROX_WHITEBOARD_SHOW_PAGE = 'hyrox-whiteboard-show-page',
  HYROX_WHITEBOARD_DEACTIVATE = 'hyrox-whiteboard-deactivate',
  EXERCISE_START = 'exercise-start',
  EXERCISE_STOP = 'exercise-stop'
}

export enum CTRL_COMMAND_FEEDBACK {

  LESSON_STARTED = 'lessonstarted',
  LESSON_PAUSED = 'lessonpaused',
  LESSON_RESUMED = 'lessonresumed',
  LESSON_STOPPED = 'lessonstopped',
  LESSON_SYNC = 'lessonsync',
  WORKOUT_STARTED = 'workout-started',
  WORKOUT_PAUSED = 'workout-paused',
  WORKOUT_RESUMED = 'workout-resumed',
  WORKOUT_STOPPED = 'workout-stopped',
  WORKOUT_GOT_FORWARD = 'workout-got-forward',
  WORKOUT_GOT_BACKWARD = 'workout-got-backward',
  WORKOUT_READY_TO_START = 'workout-ready-to-start',
  REALTIME_UPDATE_SUCCESS = 'realtime-update-success',
  PONG = 'pong',
  CELEBRATION_GOT_STARTED = 'celebration-got-started',
  HYROX_WHITEBOARD_ACTIVATED = 'hyrox-whiteboard-activated',
  EXERCISE_STARTED = 'exercise-started'
}